import { Link } from "react-router-dom";
import { useEffect } from "react";
import { activeJob, forgetJob } from "@/lib/jobs";
import { useTitle } from "@/lib/brand";
import { PageHead } from "@/components/Kit";

/** Stripe sends people here when they back out of checkout. Nothing was charged. Rebuilt 2026-10-27. */
export default function CheckoutCancelPage() {
  useTitle("Checkout cancelled");
  // the unpaid job this browser was following is no longer a training — let it go
  useEffect(() => { const id = activeJob(); if (id) forgetJob(id); }, []);
  return (
    <main data-testid="cancel-page" className="ex-page">
      <div className="ex-narrow pb-28">
        <PageHead eyebrow="Checkout cancelled" title="No charge was made." lede="Your checkout was cancelled before payment, so nothing will be trained. You can start again whenever you're ready.">
          <div className="flex flex-wrap gap-3">
            <Link to="/train" className="ex-btn ex-btn-primary">Train an Expert</Link>
            <Link to="/" className="ex-btn ex-btn-secondary">Back to home</Link>
          </div>
        </PageHead>
      </div>
    </main>
  );
}
